module.exports = __webpack_public_path__ + "static/media/time2dine-left.fbfe3acc.png";